import React from "react";

const DashIcon = ({
  width = 14,
  height = 2,
  color = "none",
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 2"
    fill="none"
    className={className}
  >
    <path
      d="M13 1L1 1"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
);

export default DashIcon;
